export default {
  CONTACT_PANEL: {
    NEW_TASK: 'New task',
    TASK_ALREADY_CREATED: 'Task already created',
    NEW_TASK_ERROR: "Couldn't create the task. Please try again.",
  },
};
